module.exports = __webpack_public_path__ + "img/03.55c5621a.jpg";